import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import useCommonActions from "../../hooks/useCommonActions";
import { ContentLoader, PageToolbar, Pagination, TooltipWrapper, RatingStar } from "../common";
import helpers from "../../_helpers/common";
import { hasAuthorization } from "../../_helpers/hasAuthorization";
import SearchForm from "./partial/SearchForm";
import KundliOrderDetail from "./KundliOrderDetail";
import AssignPanditModal from "./AssignPanditModal";
import { OrderSearchFormState, KundliPredictionOrder } from "../../types/interfaces";

const KundliOrdersList: React.FC = () => {
  const axiosInstance = useAxios();
  const { updateOrderStatus } = useCommonActions();
  const [searchForm, setSearchForm] = useState<OrderSearchFormState>({ date_range: "", search_string: "", status: "", can_search: false });
  const [results, setResults] = useState<KundliPredictionOrder[] | null>(null);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10 });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedorder, setSelectedOrder] = useState<KundliPredictionOrder | null>(null);
  const [modalopen, setModalOpen] = useState(false);
  const [assignpanditmodal, setAssignPanditModal] = useState(false);
  const isInitialRender = useRef(false);

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    getListData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  /*Handle pagination data change*/
  const handlePageChange = (page: number, pageSize: number) => {
    setPagination({ currentPage: page, pageSize });
  };

  const getListData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const response: any = await axiosInstance({
        url: "kundli-prediction-order/admin-list",
        method: "GET",
        data: {
          page: pagination.currentPage,
          limit: pagination.pageSize,
          search_string: searchForm.search_string,
          date_range: searchForm.date_range,
          status: searchForm.status,
        },
      });
     console.log("kundli-prediction-order list response", response);
      setResults(response.data.orders.docs);
      setTotalItems(response.data.orders.totalDocs);
    } catch (error: any) {
      console.error("Error in api request:", error);
    } finally {
      setTimeout(() => setIsLoading(false), 500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[pagination,searchForm]);
  
  const changeOrderStatus = (order_id: string) => {
	updateOrderStatus(order_id, `orders/update-status`, '', getListData);  
  }
  
  const showOrderDetail = (order: KundliPredictionOrder) => {
	setSelectedOrder(order);
	setModalOpen(true);
  }
  
  const assignPandit = (order: KundliPredictionOrder) => {
	setSelectedOrder(order);
	setAssignPanditModal(true);
  }


  return (
   <>
      <div className="d-flex justify-content-between">
        {/*Page toolbar Area Start*/}
        <PageToolbar title="Kundli and Prediction Orders List" />
      </div>
	  <div id="kt_content" className="content flex-column-fluid">
        {/*Search Area Start*/}
        <SearchForm searchForm={searchForm} setSearchForm={setSearchForm} handleSearchClick={getListData}/>
        {/*Search Area End*/}
        {/*Content Area Start*/}
        <div className={`card ${isLoading ? "overlay overlay-block" : ""}`}  style={{ minHeight:"70vh", maxHeight: "70vh" }} >
          <div className="card-body pt-0 pb-0 table-responsive">
		    <table className="table table-hover table-row-bordered table-row-solid">
			  <thead
				style={{
				  position: "sticky",
				  top: 0,
				  zIndex: 5,
				  backgroundColor: `${isLoading ? "#BBBCBE" : "white"}`,
				  boxShadow: "0 4px 2px -2px rgba(190, 190, 190, 0.2)",
				}}
			  >
				<tr className="text-start text-gray-800 fw-bold fs-7 text-uppercase gs-0">
				  <th>Order ID</th>
				  <th>User Name</th>
				  <th>Total Amount</th>
				  <th>Paid Amount</th>
				  <th>Payment Status</th>
				  <th>Order Status</th>
				  <th>Pandit Name</th>
				  <th>Created Date</th>
				  <th>Actions</th>
				</tr>
			  </thead>
			  <tbody className="fw-semibold text-gray-600">
				{!results || results.length === 0 ? (
				  <tr className="text-center">
					<td colSpan={9}>No Content Found</td>
				  </tr>
				) : (
				  results.map((item) => (
					<tr key={item._id}>
					  <td>
						<span className="d-inline-block">
							{item?.order_number || "N/A"}
						  </span>
					  </td>
					  <td>
						  <span className="d-inline-block">
							{typeof item.created_by === "object"
							  ? item.created_by.fullname
							  : "N/A"}
						  </span>
					  </td>
					  <td className="">{`Rs. ${item.total_amount}` || "0"}</td>
					  <td className="">
					    {`Rs. ${item.payment_status === "Upfront" ? item.upfront_amount : item.total_amount}` || "0"}
					  </td>
					  <td>
					  {item.payment_status}
					  </td>
					  <td>
					  {item.status}
					  </td>
					  <td>
						{item.pandit_id ? item.pandit_id.fullname : "Not Assigned"}
					  </td>
					  <td>
						{helpers.convertDateTime(
						  item?.created_at,
						  "DD MMM YYYY"
						) || "N/A"}
					  </td>
					  <td className="text-end">
						<div className="d-flex justify-content-end gap-2">
						  {hasAuthorization("view", "order") && (
							<TooltipWrapper title="View Details" placement="top">
							  <span
								className="btn btn-sm btn-icon btn-light btn-active-light-primary"
								onClick={() => showOrderDetail(item)}
							  >
								<i className="ki-outline ki-eye text-primary fs-2"></i>
							  </span>
							</TooltipWrapper>
						  )}
						  {hasAuthorization("assign-pandit", "order") && (
							<TooltipWrapper title="Asign Pandit" placement="top">
							  <span
								className="btn btn-sm btn-icon btn-light btn-active-light-warning"
								onClick={() => assignPandit(item)}
							  >
								<i className="ki-outline ki-fasten fs-2 text-warning"></i>
							  </span>
							</TooltipWrapper>
						  )}
						  {hasAuthorization("change_status", "order") && (
							<TooltipWrapper title="Change Status" placement="top">
							  <span
								className="btn btn-sm btn-icon btn-light btn-active-light-grey"
								onClick={() => changeOrderStatus(item?._id)}
							  >
								<i className="ki-outline ki-switch text-grey fs-2"></i>
							  </span>
							</TooltipWrapper>
						  )}
						</div>
					  </td>
					</tr>
				  ))
				)}
			  </tbody>
			</table>
		  </div>
          {/*Content Area End*/}
          {/*Pagination Start*/}
          <div
            className={`sticky-bottom bg-white border rounded p-2 shadow-sm ${
              isLoading ? "" : "border-top"
            }`}
            style={{
              bottom: 0,
              zIndex: 2,
              // backgroundColor: `${isLoading ? "#BBBCBE" : "white"}`,
            }}
          >
            {results && results.length > 0 ? (
              <Pagination
                totalItems={totalItems}
                itemsPerPage={pagination.pageSize}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
          {/*Pagination End*/}
          {/*Content Loader Start*/}
          {isLoading ? <ContentLoader /> : null}
          {/*Content Loader End*/}
        </div>
		{/*Kundli order Detail Start*/}
		{modalopen && (
		  <KundliOrderDetail order={selectedorder} handleModalOpenClose={setModalOpen}/>
		)}
		{/*Kundli order Detail End*/}
		{/*Assign Pandit Start*/}
		{assignpanditmodal && (
		  <AssignPanditModal show={assignpanditmodal} order_id={selectedorder._id} orderType='kundli-prediction' handleModalOpenClose={setAssignPanditModal} getListData={getListData}/>
		)}
		{/*Assign Pandit End*/}
      </div>
   </>
  );
};

export default KundliOrdersList;